import React from "react";
import { BaseSidebarWrapper } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
function SidebarWrapper(_ref) {
  var isOpen = _ref.isOpen,
    children = _ref.children;
  return /*#__PURE__*/_jsx(BaseSidebarWrapper, {
    isOpen: isOpen,
    children: children
  });
}
export default SidebarWrapper;